import React, { Component } from 'react'

class Lateral extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        return (
            <div>
                    <canvas className="d-grid">
                        <div><a href="https://javaguides.net" className="navbar-brand">Ciência Aberta App</a></div>
                    </canvas>

            </div>
        )
    }
}

export default Lateral